import { SalesforceApiClient } from "./salesforceApiClient";

export interface SetLanguageParams {
    language: string;
    salesforceApiClient: SalesforceApiClient;
}

export interface Language {
    label: string;
    typo3Locale: string;
    typo3LocaleId: string;
}

export interface Languages {
    [key: string]: Language;
}

/** those languages are available in Salesforce, the values for TYPO3 are often different */
export const availableLanguages: Languages = {
    de: { label: "Deutsch", typo3Locale: "de_DE", typo3LocaleId: "7" },
    en_US: { label: "English", typo3Locale: "en_US", typo3LocaleId: "10" },
    es: { label: "Español", typo3Locale: "es_ES", typo3LocaleId: "23" },
    fr: { label: "Français", typo3Locale: "fr_FR", typo3LocaleId: "16" },
    it: { label: "Italiano", typo3Locale: "it_IT", typo3LocaleId: "14" },
    ja: { label: "日本語", typo3Locale: "ja_JP", typo3LocaleId: "18" },
    sv: { label: "Svenska", typo3Locale: "sv_SE", typo3LocaleId: "21" },
    ko: { label: "한국어", typo3Locale: "ko_KR", typo3LocaleId: "6" },
    zh_TW: { label: "中文 (TW)", typo3Locale: "zh_TW", typo3LocaleId: "28" },
    zh_CN: { label: "中文 (CN)", typo3Locale: "zh_CN", typo3LocaleId: "30" },
    pt_BR: { label: "Português", typo3Locale: "pt_BR", typo3LocaleId: "27" },
    nl_NL: { label: "Nederlands", typo3Locale: "nl_NL", typo3LocaleId: "15" },
    // da: { label: "Dansk", typo3Locale: "", typo3LocaleId: "" }, // does not exist in TYPO3
    th: { label: "ไทย", typo3Locale: "th_TH", typo3LocaleId: "34" },
    // fi: { label: "Suomi", typo3Locale: "", typo3LocaleId: "" }, // does not exist in TYPO3
    // ru: { label: "Русский", typo3Locale: "", typo3LocaleId: "" }, // does not exist in TYPO3
    es_MX: { label: "Español (MX)", typo3Locale: "es_MX", typo3LocaleId: "39" },
    // no: { label: "Norsk", typo3Locale: "", typo3LocaleId: "" }, // does not exist in TYPO3
};

export const getLanguage = (locale: string): Language => {
    return availableLanguages[locale] || availableLanguages.en_US;
};

export const setLanguage = ({
    language,
    salesforceApiClient,
}: SetLanguageParams) => {
    const { baseUrl, apiVersion } =
        salesforceApiClient.getSalesforceApiConfig();
    const idTokenData = salesforceApiClient.getIdTokenData();
    const userId = idTokenData?.custom_attributes?.attr_id;
    if (!userId) {
        return Promise.resolve();
    }
    const url = `${baseUrl}/services/data/v${apiVersion}/sobjects/User/${userId}`;
    return salesforceApiClient
        .request(url, {
            method: "PATCH",
            body: {
                LanguageLocaleKey: language,
            },
        })
        .catch((error) => {
            if (error.status === 204) {
                // 204 means success but no content
                return;
            }
        });
};
